import React from 'react'
import styled from 'styled-components/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import breakpoints from 'assets/stylesheet'
import { NUTS_LEVEL_COLOR_MAPPING } from 'store/constants/constants'

const getBackgroundColor = (props, defaultValue) => {
  if (props.level) {
    return NUTS_LEVEL_COLOR_MAPPING[props.level]
  }

  return defaultValue
}

const Button = styled.button`
  color: ${props => (props.active || typeof props.level !== 'undefined' ? '#FFFFFF' : '#4A4A4A')};
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  border-radius: 4px;
  background-color: ${props =>
    getBackgroundColor(props, props.active ? '#4A4A4A' : props.background)};
  padding: 12px 8px;
  border: 0;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: ${props => NUTS_LEVEL_COLOR_MAPPING[props.level]};
  &:hover {
    box-shadow: 0 0 6px 0 #c1c1c1;
  }
  &:active {
    color: #fff;
    background-color: #a4a4a4;
  }

  &:last-child {
    margin-right: 0;
  }

  :disabled {
    background: gray;
  }

  &:focus {
    outline: none;
  }
`
const IconWrapper = styled.span`
  position: absolute;
  right: 20px;
  font-size: 30px;
  @media (max-width: ${breakpoints.bpTabletPx}) {
    right: 5px;
  }
`
const ButtonTextWrapper = styled.div``

const SubTitle = styled.span`
  font-size: 10px;
  display: block;
`

function SearchFilterButton({
  value,
  name,
  onChange,
  onFocus,
  onClick,
  color,
  background,
  active,
  subTitle,
  nutsLevel
}: {
  value: string,
  name: string,
  onChange: () => void,
  onFocus: () => void,
  onClick: () => void,
  color: string,
  background: string,
  active: boolean,
  subTitle: string,
  nutsLevel: Number
}) {
  return (
    <>
      <Button
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onClick={onClick}
        type="button"
        color={color}
        background={background}
        active={active}
        level={nutsLevel}
      >
        <ButtonTextWrapper>
          {name}
          {subTitle && <SubTitle>{subTitle}</SubTitle>}
        </ButtonTextWrapper>
        <IconWrapper>
          <FontAwesomeIcon icon={active ? ['fal', 'angle-left'] : ['fal', 'angle-right']} />
        </IconWrapper>
      </Button>
    </>
  )
}

export default SearchFilterButton
